import React, { useEffect } from 'react';
/* Helpers */
import { getPartnerEndpoints } from '../../../helpers/settings/partnerEndpoints';
import { handleAPIRequest } from '../../../helpers/handleAPIRequest';
/* Redux */
import { useSelector } from 'react-redux';
/* CSS */
import './style.css';

export const Header = ({ logo, isSimulator = false}) => {
  const token = useSelector(state => state.token);

  const handleTokenButtonClick = function (token) {
    if (token) {
      const callbacks = {
        200: function(response) {
          const { urlRitorno } = response.data;

          if (urlRitorno) {
            window.location.href = urlRitorno;
          } else {
            console.warn("Redirect non valido");
          }
        },
        400: function() {},
        500: function() {},
        default: function() {},
      };

      handleAPIRequest({
        method: 'GET',
        url: getPartnerEndpoints("compass", token).redirect.tokenRedirect,
      }, callbacks);
    }
  }

    useEffect(() => {
      if (window.$('form').length > 0) {
        // Initialize jQuery validator
        window.V.init();
      }
    }, []);

  return (
    <>
      <header id="header" className={`header ${ isSimulator ? "simulatore-header-logo-rpp" : "header--recap"}`}>
        <button className={`header__token-button token-button ${isSimulator && token ? "token-button--is-visible" : ""}`} type="button" onClick={() => handleTokenButtonClick(token)}>
          <svg className="token-button__arrow-icon" width="18" height="26" viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.6989 12.6641L17.2831 21.5091L13.8661 25.0332L0.466309 12.6669L13.8638 0.283203L17.2837 3.80461L7.6989 12.6641Z" fill="#282828"></path>
          </svg>
          <span className="token-button__text">Torna indietro</span>
        </button>
        <div className="header__logo-wrapper header-logo-rpp">
          {
            /*
              <a href={ logo.redirect }><img src={ logo.image } alt={ logo.alt } /></a>
            */
          }
          <a href={ window.origin } target="_blank" rel="noopener noreferrer"><img src={ logo.image } alt={ logo.alt } /></a>
        </div>
        <div className="header__fake-flex-box"></div>
      </header>
      <div className="clearfix"></div>
    </>
  );
}
